import { render, staticRenderFns } from "./DisplayPlannerRemark.vue?vue&type=template&id=6d97199c&scoped=true&"
import script from "./DisplayPlannerRemark.vue?vue&type=script&lang=js&"
export * from "./DisplayPlannerRemark.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPlannerRemark.vue?vue&type=style&index=0&id=6d97199c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97199c",
  null
  
)

export default component.exports